const SettingEnum = Object.assign({
  ACTIVE: { name: 'active', value: 1 },
  INACTIVE: { name: 'inactive', value: 0 },
});

Object.freeze(SettingEnum);

function getEnumAsArray() {
  return Object.keys(SettingEnum)
    .map(key => ({
      name: SettingEnum[key].name,
      value: SettingEnum[key].value,
    }));
}

export const settingArray = getEnumAsArray();

export default SettingEnum;



// WEBPACK FOOTER //
// ./src/enum/baader/Setting.js